export interface IUserData {
    created_at?: string;
    email?: string;
    first_name?: string;
    id: string;
    approval_status?: 'pending' | 'approved' | 'rejected' | 'invited' | 'reset-psw' | 'blocked';
    last_name?: string;
    phone?: string;
    role?: "travel_designer" | "travel_advisor_member" | "traveler" | "admin" | "agency";
    specialization?: string;
    updated_at?: string;
    years_experience?: string;
    avatar_url?: string;
    logo_url?: string;
    logo_small_url?: string;
    agency_id?: string;
    // user_public_profile fields
    bio?: string;
    interests?: string[]; // Legacy field
    languages?: string[];
    certifications?: string[];
    social_links?: Record<string, string>;
    // New refactored fields
    headline?: string;
    destination_countries?: string[]; // ISO country codes
    travel_interests?: string[]; // Replaces specializations/travel_styles/interests
    gallery?: string[];
    location?: string;
    years_experience_int?: number;
    preferred_language?: 'it' | 'en';
}

export class UserData implements IUserData {
    created_at: string;
    email: string;
    first_name: string;
    id: string;
    approval_status: 'pending' | 'approved' | 'rejected' | 'invited' | 'reset-psw' | 'blocked';
    last_name: string;
    phone: string;
    role: "travel_designer" | "travel_advisor_member" | "traveler" | "admin" | "agency";
    specialization: string;

    updated_at: string;
    years_experience: string;
    avatar_url: string;
    logo_url: string;
    logo_small_url: string;
    agency_id: string;
    // user_public_profile fields
    bio?: string;
    interests?: string[]; // Legacy field
    languages?: string[];
    certifications?: string[];
    social_links?: Record<string, string>;
    // New refactored fields
    headline?: string;
    destination_countries?: string[]; // ISO country codes
    travel_interests?: string[]; // Replaces specializations/travel_styles/interests
    gallery?: string[];
    location?: string;
    years_experience_int?: number;
    preferred_language?: 'it' | 'en';

    constructor(data: IUserData) {
        this.created_at = data?.created_at;
        this.email = data?.email;
        this.first_name = data?.first_name;
        this.id = data?.id;
        this.approval_status = data?.approval_status;
        this.last_name = data?.last_name;
        this.phone = data?.phone;
        this.role = data?.role;
        this.specialization = data?.specialization;
        this.updated_at = data?.updated_at;
        this.years_experience = data?.years_experience;
        this.avatar_url = data?.avatar_url;
        this.logo_url = data?.logo_url;
        this.logo_small_url = data?.logo_small_url;
        this.agency_id = data?.agency_id;
        this.bio = data?.bio;
        this.interests = data?.interests;
        this.languages = data?.languages;
        this.certifications = data?.certifications;
        this.social_links = data?.social_links;
        this.headline = data?.headline;
        this.destination_countries = data?.destination_countries;
        this.travel_interests = data?.travel_interests;
        this.gallery = data?.gallery;
        this.location = data?.location;
        this.years_experience_int = data?.years_experience_int;
        this.preferred_language = data?.preferred_language;
    }
}